import FlightIcon from '@hashicorp/react-hds/src/components/flight-icon'
import { Button } from '@hashicorp/react-mds/src/components/button'
import s from './style.module.css'

export interface PrivateCourseSectionProps {
	heading: string
	description: string
	benefitListHeading: string
	benefits: Array<string>
	cta: {
		text: string
		url: string
	}
}

export default function PrivateCourseSection({
	heading,
	description,
	benefitListHeading,
	benefits,
	cta,
}: PrivateCourseSectionProps) {
	return (
		<div className={s.privateCourseSection}>
			<div className={s.content}>
				<h2 className={s.heading}>{heading}</h2>
				<p className={s.description}>{description}</p>
				<div className={s.cta}>
					<Button
						title={cta.text}
						url={cta.url}
						theme={{ variant: 'tertiary-neutral' }}
						linkType="inbound"
					/>
				</div>
			</div>
			<div className={s.benefits}>
				<h3 className={s.benefitListHeading}>{benefitListHeading}</h3>
				<ul className={s.benefitsList}>
					{benefits.map((benefit) => {
						return (
							<li className={s.benefit} key={benefit}>
								<span className={s.benefitIcon}>
									<FlightIcon name="check" size={24} />
								</span>
								<span className={s.benefitText}>{benefit}</span>
							</li>
						)
					})}
				</ul>
			</div>
		</div>
	)
}
